var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('img',{attrs:{"src":require("@/assets/20230829234609.png")}})])
}]

export { render, staticRenderFns }